import { render, staticRenderFns } from "./OfferGroup.vue?vue&type=template&id=8d690000&scoped=true"
import script from "./OfferGroup.vue?vue&type=script&lang=ts"
export * from "./OfferGroup.vue?vue&type=script&lang=ts"
import style0 from "./OfferGroup.vue?vue&type=style&index=0&id=8d690000&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d690000",
  null
  
)

export default component.exports